export default [{
    path: '/bridge-pay',
    name: 'bridge-pay',
    meta: {
        title: "支付成功",
        requiresAuth: false,
    },
    component: () =>
        import ( /* webpackChunkName: 'bridge-pay' */ './pay/index.vue')
}]